// Core
import { useState } from "react";
import { useTranslations } from "next-intl";

// Definitions
import { ErrorResponse, ILoginFieldForm, UseAuthLoginType } from "../types";

// Utils
import { auth } from "../actions";

export const useAuthLogin = (): UseAuthLoginType => {
  const [error, setError] = useState<ErrorResponse["violations"] | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  const tValidation = useTranslations("Validation");

  const onMutateAuth = async (mutatePayload: ILoginFieldForm) => {
    setLoading(true);
    setError([]);

    const formData = new FormData();
    formData.append("login", mutatePayload.login);
    formData.append("password", mutatePayload.password);
    formData.append("countryCode", mutatePayload.countryCode);
    formData.append("type", mutatePayload.type);

    const res = await auth(formData);

    if (res?.errors) {
      setError(res.errors);
    }

    setLoading(false);

    return res;
  };

  const renderErrorMessage = (
    propertyName: string,
    authError: ErrorResponse["violations"],
  ): string | null => {
    const foundError = authError?.find((_error) => _error.property === propertyName);
    return foundError ? tValidation(foundError.error) : null;
  };

  return {
    error,
    onMutateAuth,
    loading,
    renderErrorMessage,
  };
};
